// @ts-nocheck
import EmojiObjectsOutlinedIcon from '@material-ui/icons/EmojiObjectsOutlined'
import { Button } from 'opensolar-ui'
import React from 'react'
import { useTranslate } from 'react-admin'
import useTranslateParse from '../../../util/useTranslateParse'
import { ToolTipPropsType, TourConfigType } from '../types'
import DefaultTooltip from './DefaultToolTip'

const Tooltip = (props: ToolTipPropsType) => {
  const { handleNext, handlePrev, handleCancel } = props
  const translate = useTranslate()
  const translateParse = useTranslateParse()
  return (
    <DefaultTooltip
      title={translate('Enter Energy Usage')}
      icon={EmojiObjectsOutlinedIcon}
      content={
        <div>
          <p>
            {translate(
              "Next, let's add energy usage information. If you don't have this yet, you'll be able to use OpenSolar's defaults."
            )}
          </p>
          <p>
            {translateParse('Click <strong>Energy<strong> to proceed.', {
              strong: (label: string) => <strong>{label}</strong>,
            })}
          </p>
        </div>
      }
      actions={
        <>
          <Button
            onClick={() => handlePrev && handlePrev()}
            onTouchStart={(e) => {
              e.stopPropagation()
              if (handlePrev) {
                handlePrev()
              }
            }}
          >
            <span>{translate('Back')}</span>
          </Button>
          <Button disabled={true}>
            <span>{translate('Next')}</span>
          </Button>
        </>
      }
      arrowPlacement={'top'}
    />
  )
}

const ClickEnergy: TourConfigType = {
  spotlights: [{ targetId: 'subheader-energy', padding: 5 }],
  tooltips: [{ targetId: 'subheader-energy', placement: 'bottom', component: Tooltip }],
}

export default ClickEnergy
